import { render, staticRenderFns } from "./SdsUploadPage.vue?vue&type=template&id=28893bb9&scoped=true"
import script from "./SdsUploadPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsUploadPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SdsUploadPage.vue?vue&type=style&index=0&id=28893bb9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28893bb9",
  null
  
)

export default component.exports